import { ActivityIndicator, ScrollView } from "react-native";
import { Stack } from "expo-router";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
// @ts-expect-error baseline 2026-02-16
import { WebLayout } from "@src/components/web";
import { NotificationPreferencesForm } from "@visioni/a3s-notifications/app";
import { useNotificationPreferencesPage } from "@src/features/settings/hooks";

export default function NotificationPreferencesScreen() {
  const { theme } = useUnistyles();
  const {
    isNotificationSettingsEnabled,
    isLoading,
    isError,
    allCameras,
    sites,
    cameras,
    onToggleAllCamerasChannel,
    onToggleSiteChannel,
    onToggleCameraChannel,
    phoneNumber,
    onSavePhoneNumber,
  } = useNotificationPreferencesPage();

  if (!isNotificationSettingsEnabled) {
    return null;
  }

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainerStyle}>
          {isLoading ?
            <View py="4xl" alignItems="center">
              <ActivityIndicator color={theme.colors.text as string} />
            </View>
          : isError ?
            <View py="4xl" alignItems="center">
              <Text textStyle="sm/regular" color="textMuted">
                {"Couldn't load your notification preferences. Please try again."}
              </Text>
            </View>
          : <NotificationPreferencesForm
              allCameras={allCameras}
              onToggleAllCamerasChannel={onToggleAllCamerasChannel}
              sites={sites}
              onToggleSiteChannel={onToggleSiteChannel}
              cameras={cameras}
              onToggleCameraChannel={onToggleCameraChannel}
              phoneNumber={phoneNumber}
              onSavePhoneNumber={onSavePhoneNumber}
            />
          }
        </ScrollView>
      </WebLayout>
    </>
  );
}

const styles = StyleSheet.create((theme) => ({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
    padding: theme.spacing["3xl"],
  },
}));
